module.exports = __webpack_public_path__ + "img/27_81.795329f4.png";